import React from 'react'

export const BrandConstants = {
  theme: {
    light: {
      text: '#000000',
      accent: '#001d35',
    },
    dark: {
      text: '#ffffff',
      accent: '#001d35',
    },
  },
}
